import React from "react";
import "./home.css";
const Home = () => {
  return <div className="home">Home</div>;
};

export default Home;
